import React, { Component } from "react";
import $ from "jquery";

import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";

import css from "./SisCheckbox.module.scss";
import { HiAtSymbol } from "react-icons/hi";

class SisCheckbox extends Component {
	constructor(props) {
		super(props);

		this.checkbox = React.createRef();
		this.wrap = React.createRef();
	}

	checkboxHandler = (evt) => {
		const checked = evt.target.checked;

		$(`#${this.props.id}`).closest(`.${css.checkboxWrap}`).toggleClass(css.on);
		if (this.props.onClick) this.props.onClick(evt, checked);

		// // console.log(this.props.id + " : " + checked);
	};

	clickHandler = () => {
		this.checkbox.current.click();
	};

	render() {
		const isChecked = this.props.checked ? css.on : "";
		const checked = this.props.checked ? true : false;

		return (
			<div ref={this.wrap} className={`sisCheckboxWrap ${css.checkboxWrap} ${isChecked} ${this.props.className}`} style={this.props.styles} onClick={this.clickHandler}>
				<MdCheckBox className={`${css.checkbox} ${css.on}`} />
				<MdCheckBoxOutlineBlank className={`${css.checkbox} ${css.off}`} />
				<span>{this.props.title}</span>
				<label>
				{this.props.checked ? (
					<input id={this.props.id} ref={this.checkbox} type="checkbox" value={this.props.value} onChange={this.checkboxHandler} chekced />
				) : (
					<input id={this.props.id} ref={this.checkbox} type="checkbox" value={this.props.value} onChange={this.checkboxHandler} />
				)}
				</label>
			</div>
		);
	}
}

export default SisCheckbox;
